<div class="tw-bg-[#F7B703]/[0.04] tw-h-[90rem] md:tw-h-[40rem] tw-relative tw-flex tw-justify-center">
    <div
        class="md:tw-w-[1140px] tw-bg-white tw-rounded tw-py-12 md:tw-py-[5%] tw--top-12 md:tw--top-32 tw-mx-6 tw-absolute tw-shadow">
        <div
            class="tw-mb-10 tw-mx-8 md:tw-mx-10 tw-text-center tw-font-extrabold tw-text-xl md:tw-text-3xl tw-capitalize">
            Corporate Car
            Subscription beyond traditional Leasing
        </div>
        <div class="tw-grid md:tw-grid-cols-4 tw-mx-4 md:tw-mx-24 tw-gap-4">
            <div
                class="tw-border-[1px] tw-border-yellow tw-rounded-md tw-bg-[#F7B703]/[10%] tw-px-4 tw-pt-6 tw-h-[16rem] md:tw-h-[19rem]">
                <span><img src="/assets/images/corporate/hr.svg" alt="For the HR" class="tw-w-10"></span>
                <p class="tw-font-bold tw-py-4">For the HR</p>
                <ul class="tw-list-disc tw-pl-4 tw-text-xs tw-leading-relaxed">
                    <li>Proven <span class="tw-font-bold">Employee Attraction and Retention Tool</span></li>
                    <li><span class="tw-font-bold">Minimal Paperwork </span>and Seamless management through Dashboard &
                        Mobile app
                    </li>
                    <li><span class="tw-font-bold">Easy Transfer and upgrade </span>option</li>
                </ul>
            </div>
            <div
                class="tw-border-[1px] tw-border-yellow tw-rounded-md tw-bg-[#F7B703]/[10%] tw-px-4 tw-pt-6 tw-h-[16rem] md:tw-h-[19rem]">
                <span><img src="/assets/images/corporate/finance.svg" alt="For the Finance" class="tw-w-10"></span>
                <p class="tw-font-bold tw-py-4">For the Finance</p>
                <ul class="tw-list-disc tw-pl-4 tw-text-xs tw-leading-relaxed">
                    <li>Completely <span class="tw-font-bold">cost neutral</span></li>
                    <li><span class="tw-font-bold">Off balance sheet</span> transaction since it’s an Operating Lease
                    </li>
                    <li>Ease of lease management through <span class="tw-font-bold"> Corporate Dashboard </span>–
                        Accounts,
                        Payment, TDS, GST etc</li>
                </ul>
            </div>
            <div
                class="tw-border-[1px] tw-border-yellow tw-rounded-md tw-bg-[#F7B703]/[10%] tw-px-4 tw-pt-6 tw-h-[16rem] md:tw-h-[19rem]">
                <span><img src="/assets/images/corporate/car.svg" alt="Flexible Car Lease" class="tw-w-10"></span>
                <p class="tw-font-bold tw-py-4">Flexible Car Lease</p>
                <ul class="tw-list-disc tw-pl-4 tw-text-xs tw-leading-relaxed">
                    <li><span class="tw-font-bold">6 months to 24</span> Months Tenure</li>
                    <li>Easy transfer option on employee separation</li>
                    <li>Employees can <span class="tw-font-bold">drive their Aspirational Cars</span></li>
                </ul>

            </div>
            <div
                class="tw-border-[1px] tw-border-yellow tw-rounded-md tw-bg-[#F7B703]/[10%] tw-px-4 tw-pt-6 tw-h-[16rem] md:tw-h-[19rem]">
                <span><img src="/assets/images/corporate/employee.svg" alt="For the Employees" class="tw-w-10"></span>
                <p class="tw-font-bold tw-py-4">For the Employees</p>
                <ul class="tw-list-disc tw-pl-4 tw-text-xs tw-leading-relaxed">
                    <li><span class="tw-font-bold">Upto 30% Tax benefits</span> on their existing car or a pre-owned car
                        on
                        lease
                    </li>
                    <li><span class="tw-font-bold">End to End </span>Maintenance, service and zero dep insurance</li>
                    <li><span class="tw-font-bold">Value-added services</span> like 24X7 RSA and Pick up and Drop</li>
                </ul>
            </div>
        </div>

        <div class="tw-mt-12 tw-text-center tw-font-bold tw-px-6 md:tw-text-xl">
            PumPumPum's Car Lease is value for money.
            <div class="tw-mt-12">
                <a type="button" href="contact-us"
                    class="tw-rounded-md tw-bg-pinkDark tw-px-4 tw-py-2 tw-text-white tw-text-xs md:tw-text-sm tw-font-bold hover:tw-text-white">
                    Get in touch &nbsp;<fa-icon [icon]="faArrowRight"></fa-icon>
                </a>
            </div>
        </div>
    </div>
</div>